export default __webpack_public_path__ + "static/media/slider3.1794d6a8.png";